import moment from "moment";
import { Box, CircularProgress } from "@mui/material";
import { blue, green, orange } from "@mui/material/colors";
import type { Point, Series } from "highcharts";
import Highcharts from "../../../Components/Highcharts";
import useChartOptions from "../../../system/useChartOptions";
import { AssessmentKpiTimeSeriesGroup } from "../../../system/Domain";

interface Props {
	group?: AssessmentKpiTimeSeriesGroup;
	loading?: boolean;
}

const AssessmentKpiTimeSeriesChart = ({ group, loading }: Props) => {
	const [chartOptions] = useChartOptions();

	if (loading || !group) {
		return (
			<Box textAlign="center">
				<CircularProgress />
			</Box>
		);
	}

	const points = group.buckets.map((b) => moment(b.date).valueOf());

	return (
		<Highcharts
			options={{
				...chartOptions,
				time: {
					useUTC: false
				},
				chart: {
					...chartOptions.chart,
					height: 300
				},
				legend: {
					enabled: true,
					useHTML: true,
					labelFormatter: function (this: Point | Series) {
						const color = this.visible ? this.color : "#ffffff";
						return `<span style="color:${color}">${this.name}</span>`;
					}
				},
				tooltip: {
					shared: true,
					xDateFormat: "%d.%m.%Y"
				},
				series: [
					{
						type: "line",
						name: "Abgeschlossen",
						color: green[500],
						data: group.buckets.map((b, i) => [points[i], b.completed])
					},
					{
						type: "line",
						name: "Neu beauftragt",
						color: blue[500],
						data: group.buckets.map((b, i) => [points[i], b.processed])
					},
					{
						type: "line",
						name: "Offen",
						color: orange[500],
						data: group.buckets.map((b, i) => [points[i], b.open])
					}
				]
			}}
		/>
	);
};

export default AssessmentKpiTimeSeriesChart;
